// extracted by mini-css-extract-plugin
export default {"header":"Header_header__8KoIk","pagesName":"Header_pagesName__fyYVI"};